import { render, staticRenderFns } from "./distributionStatistics.vue?vue&type=template&id=2e657afd&scoped=true&"
import script from "./distributionStatistics.vue?vue&type=script&lang=js&"
export * from "./distributionStatistics.vue?vue&type=script&lang=js&"
import style0 from "./distributionStatistics.vue?vue&type=style&index=0&id=2e657afd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e657afd",
  null
  
)

export default component.exports